/**
 * PKCE (RFC 7636) ヘルパー
 * OAuth 認可コードフローで code 横取り攻撃を無効化する。
 * code_verifier はセッション限りの秘密として sessionStorage に保持し、
 * トークン交換時に code_verifier を提示できた者だけが交換に成功する。
 */

function base64UrlEncode(bytes: Uint8Array): string {
  let binary = "";
  bytes.forEach((b) => {
    binary += String.fromCharCode(b);
  });
  return btoa(binary).replace(/\+/g, "-").replace(/\//g, "_").replace(/=+$/, "");
}

/** ランダムな code_verifier を生成（43文字の base64url = 256bit エントロピー） */
export function generateCodeVerifier(): string {
  const bytes = new Uint8Array(32);
  crypto.getRandomValues(bytes);
  return base64UrlEncode(bytes);
}

/** code_verifier から S256 の code_challenge を計算 */
export async function computeCodeChallenge(verifier: string): Promise<string> {
  const digest = await crypto.subtle.digest(
    "SHA-256",
    new TextEncoder().encode(verifier)
  );
  return base64UrlEncode(new Uint8Array(digest));
}
